import { Box } from '@mui/material';

import { useTransl } from 'shared/lib/i18n';

import PhoneNumber from './PhoneNumberComponent';
import TextFieldComponent from './TextFieldComponent';

const PhoneNumberWithExtension = (props) => {
  const { t } = useTransl();
  return (
    <Box width="100%" display="flex">
      <Box width="65%" pr="2rem">
        <PhoneNumber {...props} placeholder={t('title.phoneNumber')} />
      </Box>
      <Box width="35%">
        <TextFieldComponent {...props} placeholder={t('title.extension')} />
      </Box>
    </Box>
  );
};

export default PhoneNumberWithExtension;
